import React, { useMemo } from 'react'
import * as S from './LegendStyles'
import { LegendItem, legendZone } from 'types/RuntimeHistory'
import { SelectedLegends, SelectedZone } from '.'

type ZoneLegendProps = {
  data: Array<Required<LegendItem>>;
  selectedLegends: SelectedLegends;
  zones: Array<Required<legendZone>>;
  onFilterSelectionChanged: (zone: SelectedZone, isChecked: boolean) => void;
}

const ZoneLegendItem = ({
  data,
  zones = [],
  selectedLegends,
  onFilterSelectionChanged
}: ZoneLegendProps) => {
  const isZoneSelected = (zone) => {
    return (
      selectedLegends?.zoneSeries?.[zone.zoneIndex]?.series?.includes(
        zone.seriesName
      ) ?? false
    )
  }

  const formatedIndoorZones = useMemo(() => {
    return data.map(indoor => ({
      seriesName: indoor.seriesName,
      label: indoor.label,
      zones: zones.map(zone => zone.name)
    }))
  }, [data, zones])

  return (
    <S.ListGroup direction="column">
      <S.Typography marginBottom={10}>Indoor</S.Typography>
      <S.ZoneSection columns={zones.length} role="grid">
        <S.Typography size={12}>Zones</S.Typography>
        {
          zones.map(zone => (
            <S.Typography size={12} role="columnheader" key={zone.name} alignCenter marginBottom={10}>{zone.name}</S.Typography>
          ))
        }
        {
        formatedIndoorZones.map(indoor => {
          return (
            <React.Fragment key={indoor.seriesName}>
              <S.Typography size={12} fontWeight={400}>{indoor.label}</S.Typography>
              {
                indoor.zones.map((zone, zoneIndex) => (
                  <S.FilterCheckbox
                      alignCenter
                       key={indoor.seriesName + zone}
                       label={''}
                       listId={indoor.seriesName + zone}
                       checked={isZoneSelected({
                         seriesName: indoor.seriesName,
                         zoneIndex
                       })}
                      autoWidth
                      onChange={(e) =>
                        onFilterSelectionChanged(
                          {
                            seriesName: indoor.seriesName,
                            zoneIndex
                          },
                          e.target.checked
                        )
                      }
                  />
                ))
              }
            </React.Fragment>
          )
        })
      }
      </S.ZoneSection>
    </S.ListGroup>
  )
}

export default ZoneLegendItem
